/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsReplyTimes } from './WebApiModelsReplyTimes';
import {
    WebApiModelsReplyTimesFromJSON,
    WebApiModelsReplyTimesFromJSONTyped,
    WebApiModelsReplyTimesToJSON,
} from './WebApiModelsReplyTimes';

/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto {
    /**
     * Gets or sets the identifier.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    id?: number;
    /**
     * The member the reply belongs to, when it was made for a member in the register.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    memberId?: number | null;
    /**
     * True when the reply belongs to a member in the register, found through the reply, the invite
     * or the e-mail. False for a guest.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    isMember?: boolean;
    /**
     * The member number, empty for a guest.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    memberNumber?: string | null;
    /**
     * Gets or sets the name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    customerName?: string | null;
    /**
     * Gets or sets the name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    customerEmail?: string | null;
    /**
     * Gets or sets the description.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    customerAnswer?: string | null;
    /**
     * Gets or sets the description.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    authCode?: string | null;
    /**
     * Phone number from the member register, when the reply belongs to a member.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    customerPhone?: string | null;
    /**
     * 
     * @type {Array<WebApiModelsReplyTimes>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto
     */
    replyTime?: Array<WebApiModelsReplyTimes> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto {
    return WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'isMember': !exists(json, 'isMember') ? undefined : json['isMember'],
        'memberNumber': !exists(json, 'memberNumber') ? undefined : json['memberNumber'],
        'customerName': !exists(json, 'customerName') ? undefined : json['customerName'],
        'customerEmail': !exists(json, 'customerEmail') ? undefined : json['customerEmail'],
        'customerAnswer': !exists(json, 'customerAnswer') ? undefined : json['customerAnswer'],
        'authCode': !exists(json, 'authCode') ? undefined : json['authCode'],
        'customerPhone': !exists(json, 'customerPhone') ? undefined : json['customerPhone'],
        'replyTime': !exists(json, 'replyTime') ? undefined : (json['replyTime'] === null ? null : (json['replyTime'] as Array<any>).map(WebApiModelsReplyTimesFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceGetAnswerResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'memberId': value.memberId,
        'isMember': value.isMember,
        'memberNumber': value.memberNumber,
        'customerName': value.customerName,
        'customerEmail': value.customerEmail,
        'customerAnswer': value.customerAnswer,
        'authCode': value.authCode,
        'customerPhone': value.customerPhone,
        'replyTime': value.replyTime === undefined ? undefined : (value.replyTime === null ? null : (value.replyTime as Array<any>).map(WebApiModelsReplyTimesToJSON)),
    };
}

